import { ActionTree, Commit } from 'vuex';
import { IState } from './state';
import config from '@/params/config';
import * as TYPES from './types';
import { apiFetchAction } from '../apiUtil';

// const apiRoot: string = `${config.neo}/${config.apiVersion}`;
const apiRoot: string = config.neo;

interface IActionContent {
    state: IState;
    commit: Commit;
}

const changesearchObj = (content: IActionContent, payload: object) => {
    content.commit(TYPES.CHANGE_SEARCH_KEY, payload);
};

// 全局搜索
const getGlobalSearch = async (content: IActionContent, payload: object) => {
    await apiFetchAction(
        content.commit,
        'Search/Search',
        'GET',
        TYPES.GLOBAL_SEARCH_META,
        payload, false, apiRoot);
};

// 全局搜索 -- 公告
const getGlobalSearchNotice = async (content: IActionContent, payload: object) => {
    await apiFetchAction(
        content.commit,
        'Search/SearchNews',
        'GET',
        TYPES.GLOBAL_SEARCH_META,
        payload, false, apiRoot);
};

// 全局搜索 -- 文档
const getGlobalSearchDoc = async (content: IActionContent, payload: object) => {
    await apiFetchAction(
        content.commit,
        'Search/SearchDocuments',
        'GET',
        TYPES.GLOBAL_SEARCH_META,
        payload, false, apiRoot);
};

// 全局搜索 -- 课程
const getGlobalSearchClass = async (content: IActionContent, payload: object) => {
    await apiFetchAction(
        content.commit,
        'Search/SearchCourses',
        'GET',
        TYPES.GLOBAL_SEARCH_META,
        payload, false, apiRoot);
};

export const actions = {
    changesearchObj,
    getGlobalSearch,
    getGlobalSearchNotice,
    getGlobalSearchDoc,
    getGlobalSearchClass
};
